const formatModalidad = (value) => {
  const modalidades = {
    en_linea: "En línea",
    presencial: "Presencial",
    hibrida: "Híbrida",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const Modalidad = ({ value }) => {
  if (!value) return null;

  return (
    <>
     {formatModalidad(value)}
    </>
  );
};

export default Modalidad;